(function() {
  // Define your hardcoded label updates here
  const labelMappings = {
    'company_name': 'Registered company name',
    'shipping_address_recipient': 'Trading company name',
    'shipping_address_address1': 'Address line 1',
    'shipping_address_address2': 'Address line 2'
  };

  const updateFieldLabels = (shadowRoot) => {
    Object.keys(labelMappings).forEach((fieldId) => {
      const newText = labelMappings[fieldId];

      // 1. Target the label element by its ID
      const labelElement = shadowRoot.querySelector(`#label-${fieldId}`);
      if (labelElement) {
        labelElement.textContent = newText;
      }

      // 2. Target the corresponding input/textarea to update its placeholder text
      const inputElement = shadowRoot.querySelector(`#${fieldId}`);
      if (inputElement) {
        inputElement.setAttribute('placeholder', newText);
        // Also update aria-label for accessibility matching
        if (inputElement.hasAttribute('aria-label')) {
          inputElement.setAttribute('aria-label', newText);
        }
      }
    });
  };

  const processCustomHeaders = (shadowRoot) => {
    const fieldContainers = shadowRoot.querySelectorAll('._formFieldContainer_1mxsl_5');

    fieldContainers.forEach((container) => {
      const labelElement = container.querySelector('label');
      if (!labelElement) return;

      const rawText = labelElement.textContent.trim();

      // Handle SUBHEADER Case
      if (rawText.startsWith('SUBHEADER:')) {
        const cleanSubheadingText = rawText.replace(/^SUBHEADER:\s*/i, '').trim();
        const subheaderBlock = document.createElement('div');
        subheaderBlock.className = 'custom-form-section-subheader';
        subheaderBlock.style.width = '100%';
        subheaderBlock.style.margin = '16px 0 8px 0';
        subheaderBlock.style.clear = 'both';
        
        subheaderBlock.innerHTML = `
          <h4 style="
            font-family: 'baskerville-urw', serif !important;
            font-weight: 400 !important;
            color: #4C4C4C !important;
            font-size: 16px !important;
            margin: 0 !important;
            padding: 0 !important;
            text-transform: none !important;
          ">${cleanSubheadingText}</h4>
        `;
        container.parentNode.replaceChild(subheaderBlock, container);
      } 
      // Handle MAIN HEADER Case
      else if (rawText.startsWith('HEADER:')) {
        const cleanHeadingText = rawText.replace(/^HEADER:\s*/i, '').trim();
        const headerBlock = document.createElement('div');
        headerBlock.className = 'custom-form-section-header';
        headerBlock.style.width = '100%';
        headerBlock.style.margin = '32px 0 16px 0';
        headerBlock.style.clear = 'both';
        
        headerBlock.innerHTML = `
          <h3 style="
            font-family: 'baskerville-urw', serif !important;
            font-weight: 400 !important;
            color: #4C4C4C !important;
            font-size: 24px !important;
            margin: 0 !important;
            padding: 0 !important;
            text-transform: none !important;
          ">${cleanHeadingText}</h3>
        `;
        container.parentNode.replaceChild(headerBlock, container);
      }
      // Handle PLAIN TEXT Case
      else if (rawText.startsWith('TEXT:')) {
        const cleanPlainValue = rawText.replace(/^TEXT:\s*/i, '').trim();
        const textBlock = document.createElement('div');
        textBlock.className = 'custom-form-section-text';
        textBlock.style.width = '100%';
        textBlock.style.margin = '8px 0 16px 0';
        textBlock.style.clear = 'both';
        
        textBlock.innerHTML = `
          <p style="
            font-family: 'futura-pt', sans-serif !important;
            font-weight: 400 !important;
            font-size: 16px !important;
            color: #4C4C4C !important;
            margin: 0 !important;
            padding: 0 !important;
            line-height: 1.5 !important;
          ">${cleanPlainValue}</p>
        `;
        container.parentNode.replaceChild(textBlock, container);
      }
    });
  };

  const applyShadowStylesAndLogic = () => {
    const embedRoot = document.querySelector('shopify-forms-embed');
    
    if (embedRoot && embedRoot.shadowRoot) {
      const shadow = embedRoot.shadowRoot;

      // Inject styling overrides if not already present
      if (!shadow.querySelector('#shadow-custom-overrides')) {
        const style = document.createElement('style');
        style.id = 'shadow-custom-overrides';
        style.textContent = `
          h2, [class*="_textHeading"] {
            font-family: "baskerville-urw", serif !important;
            font-weight: 400 !important;
            color: #4C4C4C !important;
            font-size: 32px !important;
            text-transform: none !important;
            padding-top: 48px !important;
            padding-bottom: 32px !important;
            display: block !important;
          }
          /* --- Global P Tag and Label Font Override --- */
          p, 
          label, 
          span[class*="_textBody"], 
          [class*="_formInputFieldLabel"] {
            font-family: "futura-pt", sans-serif !important;
            font-weight: 400 !important;
            font-size: 16px !important;
          }
          input, textarea, button, 
          [class*="_formInputField"], 
          [class*="_formSubmitButton"], 
          [class*="_textArea"] {
            border-radius: 0px !important;
          }
        `;
        shadow.appendChild(style);
      }

      // Execute updates inside the shadow tree
      updateFieldLabels(shadow);
      processCustomHeaders(shadow);
    }
  };

  // Run immediately on page load
  applyShadowStylesAndLogic();

  // Watch for asynchronous form loading states
  const observer = new MutationObserver(() => {
    applyShadowStylesAndLogic();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();